import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The public npm registry is a database of JavaScript packages, each comprised of software and metadata. Open source developers and developers at companies use the npm registry to contribute packages to the entire community or members of their organizations, and download packages to use in their own projects.`}</p>
    <p>{`To get started with the registry, `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/signup"
      }}>{`sign up for an npm account`}</a>{` and check out the "`}<a parentName="p" {...{
        "href": "/getting-started"
      }}>{`Getting started`}</a>{`" and `}<a parentName="p" {...{
        "href": "/cli-documentation"
      }}>{`CLI`}</a>{` documentation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      